/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

import type { ItemFrame } from "../../../shared/contracts";
import { ItemState } from "../../core/item-state";
import { degToRad } from "../../math/float";

export class HitTargetState extends ItemState {
  /** Drop targets: how far the target is below its up position (0 or less). */
  public zOffset: number = 0;
  /** Standup targets: tilt in degrees. */
  public xRotation: number = 0;
  private readonly isDrop: boolean;

  public constructor(name: string, isDrop: boolean, isVisible: boolean) {
    super();
    this.name = name;
    this.isDrop = isDrop;
    this.isVisible = isVisible;
  }

  /** A drop target sets `offset`. A standup target sets `angle` in radians. */
  public override toFrame(): ItemFrame {
    return this.isDrop
      ? { name: this.name, kind: "target", offset: this.zOffset, visible: this.isVisible }
      : {
          name: this.name,
          kind: "target",
          angle: degToRad(this.xRotation),
          visible: this.isVisible,
        };
  }
}
